module.exports = __webpack_public_path__ + "html/video-slider_5ca79641e867e2cfaccee697f9cfe13d.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/video-slider.html
// module id = isjR
// module chunks = 23